/**
 * 멜로디 곡 커서 — 순수 상태머신 (Phaser/WebAudio/데이터 비의존).
 *
 * 멜로디 챕터에서 블록이 어떤 순서로 터지든 **곡 음 순서를 보존**한다(사용자 결정 "배치+커서 혼합"의
 * 커서 측면). 블록 파괴 1회 = `nextNote()` 1회 = 곡의 다음 음. 곡 끝에 도달하면 처음으로 wrap해 반복.
 *
 * 블록 자체에 배치된 noteId(가까운=앞음)는 색/시각용이고, 실제 재생 음정은 이 커서가 결정하므로
 * 자동 방치에서 가까운 순으로 파괴되면 배치 음 ≈ 커서 음으로 일치하고, 순서가 어긋나도 곡은 또렷하다.
 */
export class MelodySequencer {
  private notes: readonly string[] = [];
  private cursor = 0;

  /** 곡 설정 + 커서 0으로 리셋 (챕터 진입 시). */
  setSong(noteIds: readonly string[]): void {
    this.notes = noteIds;
    this.cursor = 0;
  }

  /** 커서만 0으로 (같은 곡 다시 처음부터). */
  reset(): void {
    this.cursor = 0;
  }

  /** 곡이 비어 있으면 true (멜로디 챕터가 아니거나 빈 곡 방어). */
  get isEmpty(): boolean {
    return this.notes.length === 0;
  }

  /** 현재 커서 음 반환 + 커서 전진(끝이면 처음으로 wrap). 빈 곡이면 null. */
  nextNote(): string | null {
    if (this.notes.length === 0) return null;
    const note = this.notes[this.cursor]!;
    this.cursor = (this.cursor + 1) % this.notes.length;
    return note;
  }
}
